module.exports = __webpack_public_path__ + "img/CersoLeek.ae5422bc.png";